import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FileAttachmentSingle from './FileAttachmentSingle';
import FileAttachmentGrid from './FileAttachmentGrid';
import FileAttachmentOverlay from './FileAttachmentOverlay';
import DropBox from '../../../../inputs/FileUploadButton/DropBox';
import { deleteAttachment } from '../../../../actions/apiAttachments';
import { getMpiWorkItemsByVid } from '../../../../actions/apiGetInfo';
import { getFilesViewMode, setFilesViewMode } from '../../../../utils/filesViewMode';
import './filesView.scss';

class FileAttachment extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			localAttachments: [],
			viewMode: getFilesViewMode(),
			overlayAttachment: null,
		};
		this.onChange = this.onChange.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.setViewMode = this.setViewMode.bind(this);
		this.openOverlay = this.openOverlay.bind(this);
		this.closeOverlay = this.closeOverlay.bind(this);
	}

	loadWorkItems(vehicleId) {
		if (vehicleId) {
			this.props.getMpiWorkItemsByVid(vehicleId);
		}
	}

	componentDidMount() {
		this.setState({ localAttachments: this.props.active_vehicle.attachments || [] });
		this.loadWorkItems(this.props.active_vehicle?.id);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.active_vehicle.attachments !== this.props.active_vehicle.attachments) {
			const next = this.props.active_vehicle.attachments || [];
			this.setState({ localAttachments: next });
			const { overlayAttachment } = this.state;
			if (overlayAttachment) {
				const updated = next.find(a => String(a.id) === String(overlayAttachment.id));
				if (updated) {
					this.setState({ overlayAttachment: updated });
				} else {
					this.setState({ overlayAttachment: null });
				}
			}
		}
		if (prevProps.active_vehicle?.id !== this.props.active_vehicle?.id) {
			this.loadWorkItems(this.props.active_vehicle?.id);
			this.setState({ overlayAttachment: null });
		}
	}

	onDelete = (id) => {
		const { localAttachments } = this.state;
		const newAttachments = localAttachments.filter(attachment => attachment.id !== id);
		this.props.deleteAttachment(id);
		this.setState({
			localAttachments: newAttachments,
			overlayAttachment: this.state.overlayAttachment && String(this.state.overlayAttachment.id) === String(id)
				? null
				: this.state.overlayAttachment,
		});
	};

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	setViewMode(mode) {
		this.setState({ viewMode: setFilesViewMode(mode) });
	}

	openOverlay(attachment) {
		this.setState({ overlayAttachment: attachment });
	}

	closeOverlay() {
		this.setState({ overlayAttachment: null });
	}

	renderViewToggle() {
		const { viewMode } = this.state;
		return (
			<div className="btn-group btn-group-sm mb-3" role="group" aria-label="Files view">
				<button
					type="button"
					className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
					onClick={() => this.setViewMode('list')}
				>
					List
				</button>
				<button
					type="button"
					className={`btn ${viewMode === 'thumbnail' ? 'btn-primary' : 'btn-outline-primary'}`}
					onClick={() => this.setViewMode('thumbnail')}
				>
					Thumbnail
				</button>
			</div>
		);
	}

	render() {
		const vehicle = this.props.active_vehicle;
		const { localAttachments, viewMode, overlayAttachment } = this.state;

		return (
			<div className="container files-view">
				{' '}
				<br />
				<div className="row">
					<div className="col-md-6">
						<div className="card card-default">
							<div className="card-heading" />
							<div className="card-body drop-container">
								<DropBox vid={vehicle.id} siteid={`${this.props.current_dealership}_${vehicle.id}`} />
							</div>

						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="card card-default">
							<div className="card-heading" />
							<div className="card-body">
								{this.renderViewToggle()}
								{viewMode === 'thumbnail' ? (
									<FileAttachmentGrid
										attachments={localAttachments}
										onOpen={this.openOverlay}
									/>
								) : (
									<ul className="list-group">
										{
											localAttachments.length > 0 &&
											localAttachments.map(attachment => (
												<FileAttachmentSingle
													key={`attach_${attachment.id}`}
													attachment={attachment}
													vehicle_id={vehicle.id}
													data_id={attachment.id}
													delete={this.onDelete}
													showThumbnail
													showWorkItemSelect
												/>
											))
										}
									</ul>
								)}
							</div>

						</div>
					</div>
				</div>
				{overlayAttachment && (
					<FileAttachmentOverlay
						attachment={overlayAttachment}
						vehicle_id={vehicle.id}
						onClose={this.closeOverlay}
						onDelete={this.onDelete}
					/>
				)}
			</div>
		);
	}
}

const mappedActions = {
	deleteAttachment,
	getMpiWorkItemsByVid,
};

function mapStateToProps(state) {
	return {
		current_dealership: state.settings_dealerships.current_dealership,
		active_vehicle: state.settings_refresh.active_vehicle,
	};
}
export default connect(mapStateToProps, mappedActions)(FileAttachment);
